import { createStore } from 'redux'

function counterReducer(state = { value: false }, action) {
    console.log("here", action);
    switch (action.type) {
      case 'opening':
        return { value: "opening" }
      case 'doneOpening':
        return { value: "doneOpening" }
      case 'closing':
        return { value: "closing" }
      case 'doneClosing':
        return { value: "doneClosing" }
      default:
        return state
    }
  }

export const store = createStore(counterReducer)


